// React and React-related imports
import React from 'react';
import ReactDOM from 'react-dom/client';

// Third-party libraries
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';

// Local imports
import App from './App';
import { lightTheme } from './theme/theme';
import { SessionProvider } from './context/SessionContext';

// Styles
import './index.css';
import './App.css';

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Initialize QueryClient with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Additional options like staleTime or cacheTime can be set here
    },
  },
});

// Render application
root.render(
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ThemeProvider theme={lightTheme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </SessionProvider>
      {/* Optional: React Query Devtools for debugging */}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </LocalizationProvider>
);
